import React from 'react'
import { EmptyState } from '@driftt/crm-components'
import { MarketoAccessTypes, getOrgMarketoAccessType } from 'utils/marketoAccess';

const PRICING_URL = 'https://www.drift.com/pricing/#enterprise'

const MarketoAccessTypeConfig = {
  [MarketoAccessTypes.HAS_ACCESS_CONNECTED]: {
    topText: "Get started with Marketo Lists in Drift!",
    bottomText: "Serve up more personalized experiences by sending specific playbooks to your Marketo Lists.",
    buttonTitle: "Import a Marketo List",
    buttonHref: "/imports/marketo"
  },
  [MarketoAccessTypes.HAS_ACCESS_NOT_CONNECTED]: {
    topText: "Want to send personalized playbooks to your Marketo Lists?",
    bottomText: "Connect the Marketo integration to start importing Marketo Lists!",
    buttonTitle: "Connect Marketo",
    buttonHref: "/settings/setup/marketo"
  },
  [MarketoAccessTypes.NO_ACCESS]: {
    topText: "Want to send personalized playbooks to your Marketo Lists?",
    bottomText: "Upgrade your Drift plan to start importing Marketo Lists!",
    buttonTitle: "Upgrade to Company",
    buttonHref: PRICING_URL
  },
}

export default ({ history }) => {
  const accessType = getOrgMarketoAccessType()
  const tooltipConfig = MarketoAccessTypeConfig[accessType]

  return (
    <EmptyState
      history={history}
      topText={tooltipConfig.topText}
      bottomText={tooltipConfig.bottomText}
      ctaText={tooltipConfig.buttonTitle}
      ctaUrl={tooltipConfig.buttonHref}
    />
  )
}
